export const CTA_BUTTON_TEXT = `להבטחת שכר הדירה`

export const DISCLAIMER = `*הכל בכפוף לתנאי החברה ולהסכם ההתקשרות המלא. בכל מקרה של סתירה או אי התאמה בין האמור כאן להוראות הסכם ההתקשרות יגבר האמור בהסכם ההתקשרות.`